var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationAlarm2 = function SvgNotificationAlarm2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB4D4D",
    stroke: "#EB4D4D",
    d: "M10.75 5.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M9.933 8v1.534c0 .39.155.766.432 1.042.276.277.744.432 1.135.432H.5c.391 0 .859-.155 1.135-.432.277-.276.432-.651.432-1.042V5.933A3.933 3.933 0 0 1 6 2M5 13.5h2"
  }))));
};
export default SvgNotificationAlarm2;